import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useMediaQuery } from '@mui/material';
import Info from '../../components/common/Info';
import ResultBox from '../../components/common/ResultBox';
import RoundInfo from '../../components/common/RoundInfo';
import SubInfo from '../../components/common/SubInfo';
import GapAround from '../../components/hoc/GapAround';
import { PROJECTS_DELIVERED } from '../../constants/stats';
import { imageUrl } from '../../utils';

const WhyUs = () => {
  const rocketImage = imageUrl('rocket.svg');

  const isLessThan1280 = useMediaQuery('(max-width: 1280px)');

  return (
    <GapAround spaceTaken={2} containerClass="overflow-hidden pb-0 md:pb-12">
      <div className="w-full flex flex-col space-y-[73px] breaktwo:space-y-12" id="whyus">
        <div
          className="bg-top absolute w-[calc(100%+40px)] mx-[-20px] h-full -z-10 opacity-0 breaktwo:opacity-20"
          style={{ backgroundImage: `url(${imageUrl('rocket.svg')})`, backgroundSize: `250px` }}></div>
        <div className="flex flex-col breaktwo:items-center space-y-4 breaktwo:text-center">
          <RoundInfo>Your team</RoundInfo>
          <Info variant={'h2'}
            typographyStyles={{
              fontSize: isLessThan1280 ? 28 : 42,
            }}
            containerClasses="w-[90%] mdmax:w-[100%] breaktwomin:w-[50%]">
            {'Your dedicated team for healthier, stronger software.'}
          </Info>
          <div className="w-[90%] mdmax:w-[100%] pb-4 breaktwomin:w-[50%]">
            <SubInfo>{'Behind every successful project is an experienced team. Meet the key experts who bring the engineering, design, and problem-solving expertise that keeps our clients’ software healthy.'}</SubInfo>
          </div>
        </div>
        <div className="absolute right-[18%] bottom-52 -z-10 breaktwo:hidden">
          <img loading="lazy" src={rocketImage} alt="rocket" className="rocket-float" />
        </div>
      </div>

      <div className="flex mdmax:flex-wrap mdmax:space-y-5 justify-between lg:space-x-10 md:space-x-5 mdmax:pb-[20px]">
        <ResultBox
          containerClasses="bg-light-gray/[0.4] p-3 md:p-5 xl:p-10 mdmax:w-[100%]"
          heading={`${PROJECTS_DELIVERED}+`}
          subheading={'Happy clients from the results we offer'}
          describeImage="happyfaces.svg"
          className="isMin1280:!text-[60px] isMin1150:!text-[54px] !text-[48px]"
          subHeadingClass="!text-[16px]"
          iconClass="w-[60px] h-[70px] pt-[7px]"
          imgClass="w-[100%]"
          alt="happyfaces"
        />
        <ResultBox
          containerClasses="bg-light-gray/[0.3] p-3 md:p-5 xl:p-10 mdmax:w-[100%]"
          heading="4.9+/5"
          subheading={
            <>
              {'Average rating with top rated plus badge on Upwork'}{' '}
              <a
                href="https://www.upwork.com/agencies/atinistudio/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="View Atini Studio on Upwork"
                className="inline-flex items-center gap-1 align-middle hover:opacity-80">
                <img
                  loading="lazy"
                  className="inline-block w-[18px] h-[18px]"
                  src={imageUrl('upwork-green.svg')}
                  alt=""
                />
                <ArrowForwardIcon style={{ fontSize: 16 }} />
              </a>
            </>
          }
          describeImage="stars.svg"
          className="isMin1280:!text-[60px] isMin1150:!text-[54px] !text-[48px]"
          subHeadingClass="!text-[16px]"
          iconClass="w-[45px] h-[48px] pt-[1px]"
          alt="stars"
        />
        <ResultBox
          containerClasses="bg-light-gray/[0.2] p-3 md:p-5 xl:p-10 mdmax:w-[100%]"
          heading="1M+"
          subheading={'Revenue that can be tracked across our portfolio'}
          describeImage="earnings_icon2.svg"
          className="isMin1280:!text-[60px] isMin1150:!text-[54px] !text-[48px]"
          subHeadingClass="!text-[16px]"
          iconClass="w-[45px] h-[48px] pt-[2px]"
          alt="earnings icon2"
        />
      </div>
    </GapAround>
  );
};

export default WhyUs;
